import type { UserLocation } from 'fitify-ui/src/server/types/user-location'
import { useEffect, useState } from 'react'

export const useUserCountry = (): string | null => {
  const [countryCode, setCountryCode] = useState<string | null>(null)

  useEffect(() => {
    const detectLocation = async () => {
      const res = await fetch('/api/detect-location', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      })
      const data = res.ok ? ((await res.json()) as UserLocation) : null
      data?.countryCode && setCountryCode(data?.countryCode)
    }

    void detectLocation()
  }, [])

  return countryCode
}
